import React from 'react';
import './ReportAnalysisForm.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import Description from "./Description";

const ReportAnalysisForm = ({data}) => {
  return (
    <>
      {data?.data?.data.map((item, index) => (
        <React.Fragment key={index}>
          <section className="print__need">
            <HeaderPrint
              englishTitle={"Needs analysis form"}
              persianTitle={"فرم تحلیل گـزارش"}
              color={"#A6017E"}
            />
            <div className="print__need__text__box">
              <div className="print__need__text iransans-b">
                <div className="print__subsystems__name">
                  <span>نام سیستم</span>
                  <span>:</span>
                  <span>{item.name}</span>
                </div>
                <div
                  style={{alignItems: "center"}}
                  className="print__subsystems__phone"
                >
                  <span>خروجی گزارش</span>
                  <span>:</span>
                  <div className="print__checkbox">
                    <input type="checkbox" name="" id=""/>
                    <span>report</span>
                    <input
                      className="print__checkbox__margin"
                      type="checkbox"
                      name=""
                      id=""
                    />
                    <span>Grid</span>
                    <input
                      className="print__checkbox__margin"
                      type="checkbox"
                      name=""
                      id=""
                    />
                    <span>Chart</span>
                  </div>
                </div>
              </div>
              <div className="print__need__text iransans-b">
                <div>
                  <span>کد گزارش</span>
                  <span>:</span>
                  <span>ایپسوم</span>
                </div>
              </div>
              <div className="print__need__text iransans-b">
                <div className="print__subsystems__phone">
                  <span>تاریخ</span>
                  <span>:</span>
                  <span>{item.date}</span>
                </div>
                <div>
                  <span>مصاحبه / منبع</span>
                  <span>:</span>
                  <span>1</span>
                </div>
              </div>
            </div>
            <Description items={item}/>
          </section>
          {index < data?.data?.data.length - 1 && (
            <div style={{pageBreakBefore: "always"}}></div>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default ReportAnalysisForm;